import axios from 'axios';
import Cookies from "js-cookie";

const api = axios.create({
    baseURL: process.env.REACT_APP_URL_API,
    withCredentials: true,
});

const publicApi = axios.create({
    baseURL: process.env.REACT_APP_URL_API,
});

async function handleLogout() {
    try {
        await api.post('/users/logout');
    } finally {
        window.location.href = '/login';
    }
}

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            handleLogout();
        }
        return Promise.reject(error);
    }
);

export {
    api,
    publicApi,
    handleLogout
};